// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-wCGBhw{padding-bottom:24px}.wrapper-wCGBhw.left-zs1fUo .header-ptLrG7{padding:0 28px 6px}.wrapper-wCGBhw.center-tdZhpq .header-ptLrG7{height:22px;padding:0 8px 6px;font-size:12px;font-weight:500;line-height:22px}.wrapper-wCGBhw .header-ptLrG7{border:none;align-items:center;display:flex}.wrapper-wCGBhw .header-ptLrG7 .title-QEAsqN{flex:1;font-size:14px;font-weight:600;line-height:20px}.wrapper-wCGBhw .collapse-panel-hide-underline>div{border-bottom:1px solid transparent}.display-none-tm6ZJZ{display:none}:nth-child(1 of .wrapper-wCGBhw) .header-ptLrG7{border-top:none;border-bottom:none;margin-top:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper-wCGBhw`,
	"left": `left-zs1fUo`,
	"header": `header-ptLrG7`,
	"center": `center-tdZhpq`,
	"title": `title-QEAsqN`,
	"display-none": `display-none-tm6ZJZ`,
	"displayNone": `display-none-tm6ZJZ`
};
export default ___CSS_LOADER_EXPORT___;
